/** @jsx jsx */
import { jsx } from '@emotion/core'
import React from 'react'
import { observer } from 'mobx-react'
import useRootStore from '@store/useRootStore'
import { isMobile } from 'react-device-detect'
import { Badge } from 'antd-mobile'
// img
import messageCharacter from '@assets/images/bg/character/message-alert-character.png'
import messageCharacterHands from '@assets/images/bg/character/message-alert-character-hands.png'
import messageBodyImg from '@assets/images/bg/message-alert-body.png'
import messageHeadImg from '@assets/images/bg/message-alert-head.png'
import messageShadowImg from '@assets/images/bg/message-alert-shadow.png'
import seasonMessageCharacter from '@assets/images/bg/season-bg/season-message-alert-character.png'
import seasonMessageCharacterHands from '@assets/images/bg/season-bg/season-message-alert-character-hands.png'
import seasonMessageBallImg from '@assets/images/bg/season-bg/season-message-ball.png'
import seasonMessageBodyImg from '@assets/images/bg/season-bg/season-message-alert-body.png'
import seasonMessageHeadImg from '@assets/images/bg/season-bg/season-message-alert-head.png'
import messageDecoImgUrl from '@assets/images/bg/season-bg/season-message-deco.png'
// css
import { Button } from '@styles/button.style'
import { BadgeStyle } from '@styles/base.style'
import { MessageAlertWrapper } from './index.style'

const MessageArrivalButton: React.FC = () => {
  const { globalStore, userStore, messageStore, componentStore } = useRootStore()
  const { notificationData } = userStore

  let timer = null

  const onClickMessageToggleButton = async () => {
    clearTimeout(timer)
    timer = setTimeout(async () => {
      await messageStore.getOneUnQuickReadMessageByUserId()
      const { unQuickReadUserMessage } = messageStore

      if (unQuickReadUserMessage) {
        componentStore.setExtraClubId(null)
        globalStore.setVisibleQuickMessagePopup(true)
      } else {
        userStore.decreaseUnQuickReadMessageCount()
        userStore.decreaseUnReadMessageCount()
      }
    }, 500)
  }

  const makeMessageWrapperClassName = (): string => {
    const baseClass = isMobile ? 'message-wrapper' : 'message-wrapper pc'

    if (notificationData?.unQuickReadMessageCount > 0 && !globalStore.visibleTutorialPopup
      && !globalStore.visibleMatchFilterPopup && globalStore.isMessageSeasonEffect()) {
      return `${baseClass} season-effect`
    }

    if (notificationData?.unQuickReadMessageCount > 0 && !globalStore.visibleTutorialPopup
      && !globalStore.visibleMatchFilterPopup) {
      return baseClass
    }
    return 'adv-hidden'
  }


  const messageShadowImgUrl = messageShadowImg // 공통된 그림자 이미지에셋 사용
  let messageCharacterImgUrl: string = messageCharacter
  let messageCharacterHandsImgUrl: string = messageCharacterHands
  let messageBodyImgUrl: string = messageBodyImg
  let messageHeadImgUrl: string = messageHeadImg

  if (globalStore.isMessageSeasonEffect()) {
    messageCharacterImgUrl = seasonMessageCharacter
    messageCharacterHandsImgUrl = seasonMessageCharacterHands
    messageBodyImgUrl = seasonMessageBodyImg
    messageHeadImgUrl = seasonMessageHeadImg
  }

  return (
    <MessageAlertWrapper className={makeMessageWrapperClassName()}>
      {/* 버튼을 눌러 메시지 미리보기 모달이 호출 될 시 Button에 'open' class를 추가해주시면 됩니다. */}
      <Button className={`message-alert-btn ${globalStore.visibleQuickMessagePopup ? 'open' : ''}`}
              onClick={onClickMessageToggleButton}>
        <div className="bubble-message">
          읽지 않은 메시지가 있습니다.
        </div>
        <img src={messageCharacterImgUrl} alt="메세지 캐릭터" className="message-alert-character"/>
        <div className="message-ball">
          {globalStore.isMessageSeasonEffect() &&
            <img src={seasonMessageBallImg} alt="메세지 볼 배경" className="message-ball-bg"/>
          }
          <span className="message-ico">
            <img src={messageBodyImgUrl} alt="메세지" className="message-body"/>
            <img src={messageShadowImgUrl} alt="메세지" className="message-shadow"/>
            <img src={messageHeadImgUrl} alt="메세지" className="message-head"/>
            {globalStore.isMessageSeasonEffect() && !globalStore.visibleQuickMessagePopup &&
              <img src={messageDecoImgUrl} alt="메세지 장식" className="message-deco"/>
            }
          </span>
          <img src={messageCharacterHandsImgUrl} alt="메세지 캐릭터 손" className="message-alert-character-hands"/>
          <Badge text={notificationData?.unQuickReadMessageCount || 0} overflowCount={99} css={BadgeStyle}
                 className="badge-style"/>
        </div>
      </Button>
    </MessageAlertWrapper>

  )
}

export default observer(MessageArrivalButton)
